module.exports = __webpack_public_path__ + "images/8a3d4f66ab53e699509b43570f4115b3.jpg";